<template>
  <v-dialog ref="dialog" v-model="modal" :return-value.sync="time" width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        :disabled="disabled"
        class="card-border"
        v-model="showtime"
        label="เลือก"
        append-icon="access_time"
        @click:append="openModal"
        readonly
        hide-details
        solo
        flat
      ></v-text-field>
    </template>
    <v-time-picker
      v-model="time"
      scrollable
      color="primary"
      @change="saveTime"
      format="24hr"
      :min="min"
      :max="max"
    >
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="clearData">ล้าง</v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  name: 'TimePicker',
  data() {
    return {
      time: '',
      modal: false
    };
  },
  props: {
    defaultTime: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      type: String,
      default: undefined
    },
    max: {
      type: String,
      default: undefined
    }
  },
  mounted() {
    if (this.defaultTime !== '' && this.defaultTime !== undefined) {
      this.time = this.timeformat(this.defaultTime);
      this.saveTime();
    }
  },
  computed: {
    showtime() {
      if (this.time) {
        return this.timeformat(this.time);
      }
      return '';
    }
  },
  methods: {
    saveTime() {
      this.$refs.dialog.save(this.time);
      this.$emit('input', this.time);
    },
    setDefaultData(defaultTime) {
      // this.time = this.defaultTime;
      this.time = this.timeformat(defaultTime);
      // this.$refs.dialog.save(this.time);
      this.saveTime();
    },
    clearData() {
      this.time = '';
      this.saveTime();
      // this.$refs.dialog.save(this.time);
    },
    timeformat(time) {
      const t = time.split(':');
      const h = parseInt(t[0]) > 9 ? `${parseInt(t[0])}` : `0${parseInt(t[0])}`;
      const m = parseInt(t[1]) > 9 ? `${parseInt(t[1])}` : `0${parseInt(t[1])}`;
      return `${h}:${m}`;
    },
    openModal() {
      this.modal = true;
    }
  },
  watch: {
    defaultTime(time) {
      this.setDefaultData(time);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
